import richText from "utilities/richText"
import useWindowSize from "utilities/useWindowSize"
import NextImage from "next/image"

export default function ScrollingSection({ blok }) {
  const width = useWindowSize().width

  const section = "relative overflow-hidden lg:px-5 pt-14 lg:py-16"

  const container = "image-content-container flex flex-col lg:flex-row lg:justify-between gap-8 mx-auto max-w-screen-xl"

  return (
    <section className={section}>
      <div className="z-[-1]">
        <NextImage
          alt=""
          src={width <= 768 ? "/assets/blue-weave-mobile.webp" : "/assets/blue-weave.webp"}
          quality={80}
          fill
          blurDataURL={blok.image?.blurDataURL}
          blur
          sizes="100vw"
          style={{
            objectFit: "cover",
          }}
        />
      </div>
      <div className={container}>
        <div className="basis-1/2 image-content text-white px-5 lg:px-0 z-10">
          {blok.eyebrow ? (
            <div className="uppercase py-2 flex">
              <span className="eyebrow text-white">{blok.eyebrow}</span>
            </div>
          ) : null}
          <h2 className="text-white mb-6">{blok.heading}</h2>
          <div className="prose-ul:pl-3">{richText(blok.content)}</div>
        </div>
        <div className="basis-1/2  bg-highlight-tint w-full shadow-inset z-10 min-h-[450px] lg:overflow-scroll lg:overflow-x-hidden lg:max-h-[750px] scrollbar">
          <div className="z-10 p-7 pb-14 lg:pb-7 text-primary prose prose-p:mt-0">
            {richText(blok.scrolling_content)}
          </div>
        </div>
      </div>
    </section>
  )
}
